import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import moment from "moment";
import { columns } from "./columns";
import { useSelector } from "react-redux";

import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import MuiTable from "../../../board/components/BoardTable/MuiTbale";
import Loader from "../../../../../components/Loader";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useStatusMissing } from "../../../../../utils/reactQuery/statusMissing";

export const StatusTable = React.memo(() => {
  const [filterBoard] = useCustomSearchParams("missingStatus");
  const [status, setStatus] = useState(null);
  const filterBoardObj = JSON.parse(filterBoard);
  const isMobile = useResponsive("down", "md");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const start_date = filterBoardObj
    ? moment(filterBoardObj.startDate).format("YYYY-MM-DD")
    : "";
  const end_date = filterBoardObj
    ? moment(filterBoardObj.endDate).format("YYYY-MM-DD")
    : "";

  const { isLoading, error, statusMissing, isError, refetch, isRefetching } =
    useStatusMissing({ start_date, end_date });

  useEffect(() => {
    if (statusMissing) {
      const statusData = statusMissing?.data?.data?.responseData.map(
        (item, index) => ({
          ...item,
          id: index + 1,
          notes: `${item.leave_type ? item.leave_type : "none"} ${
            item.reason ? `: ${item.reason}` : ""
          }`,
        })
      );
      setStatus(statusData);
    }
  }, [statusMissing]);

  useEffect(() => {
    refetch();
  }, [start_date, end_date]);

  return (
    <>
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        status && (
          <Box p={isMobile && 1} mt={isMobile && 1}>
            <MuiTable
              initialRows={
                (groupingUser.length > 0 && groupingUser?.[0]?.users?.length > 0)
                  ? status?.filter((item) =>
                      groupingUser?.[0]?.users?.some(
                        (user) => user?.user_id === item?.user_id
                      )
                    )
                  : status
              }
              columns={columns(isMobile)}
              defaultSort={"username"}
              headerBgColor={"#F2F4F6"}
            />
          </Box>
        )
      )}
    </>
  );
});
